var __jsx = React.createElement;
import React, { useEffect, useState } from "react";
import { useTranslation } from "@i18n";
import Countdown from 'react-countdown';
import stl from "@/components/UiKit/Tag/Tag.module.css";
import SAR from "@componentsShared/SAR/SAR";
import { useLang } from "@/common/Contexts/LanguageContext";
var PromoTag = function PromoTag(_ref) {
  var tags = _ref.tags,
    value = _ref.value,
    onClick = _ref.onClick,
    _ref$withPopUp = _ref.withPopUp,
    withPopUp = _ref$withPopUp === void 0 ? false : _ref$withPopUp;
  var _useState = useState(false),
    showPopUp = _useState[0],
    setShowPopUp = _useState[1];
  var _useState2 = useState({
      code: "",
      description: ""
    }),
    popUpData = _useState2[0],
    setPopUpData = _useState2[1];
  var _useState3 = useState(true),
    hasValidTags = _useState3[0],
    setHasValidTags = _useState3[1];
  var _useTranslation = useTranslation(["web_checkout_cash", "short"]),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var lang = useLang();
  var validTags = (tags === null || tags === void 0 ? void 0 : tags.filter(function (tag) {
    return tag && tag.code;
  })) || [];

  // Check if we have any non-expired tags initially
  useEffect(function () {
    var currentTime = new Date();
    var nonExpiredTags = validTags.filter(function (tag) {
      if (!tag.expires_at) return true; // No expiry date means always valid
      return new Date(tag.expires_at) > currentTime;
    });
    setHasValidTags(nonExpiredTags.length > 0);
  }, [validTags]);

  // Countdown renderer for HH:MM:SS format
  var countdownRenderer = function countdownRenderer(_ref2) {
    var days = _ref2.days,
      hours = _ref2.hours,
      minutes = _ref2.minutes,
      seconds = _ref2.seconds,
      completed = _ref2.completed;
    if (completed) {
      return null; // Don't show anything when expired
    }
    var formatTime = function formatTime(time) {
      return time.toString().padStart(2, "0");
    };
    var totalHours = hours + days * 24;
    return "".concat(formatTime(totalHours), ":").concat(formatTime(minutes), ":").concat(formatTime(seconds));
  };
  var formatDiscountAmount = function formatDiscountAmount(promoTag) {
    if (promoTag.discount_amount) {
      return "".concat(tShort("promo/discount", {
        ns: "web_promo"
      }), " ").concat(promoTag.discount_amount, " ");
    }
    return tShort("promo/special_discount", {
      ns: "web_promo"
    });
  };
  var handleClick = function handleClick(tag) {
    // Check if expired
    if (tag.expires_at && new Date() >= new Date(tag.expires_at)) {
      return; // Don't allow click if expired
    }
    onClick(tag.code);
  };
  if (validTags.length === 0 || !hasValidTags) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, hasValidTags && validTags.map(function (promoTag, index) {
    var isExpired = promoTag.expires_at && new Date() >= new Date(promoTag.expires_at);
    var isActive = promoTag.code === value;
    return /*#__PURE__*/React.createElement("span", {
      key: "".concat(promoTag.code, "-").concat(index)
    }, /*#__PURE__*/React.createElement("div", {
      onClick: function onClick(e) {
        e.target === e.currentTarget && handleClick(promoTag);
      },
      className: stl.tagContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(stl.tagAR, " ").concat(isActive ? stl.active : stl.inactive + " border !border-[#fe561c]", " ").concat(isExpired ? 'opacity-50 cursor-not-allowed' : '')
    }, tShort("promo/your_special_discount", {
      ns: "web_promo"
    }), promoTag.expires_at && !isExpired && /*#__PURE__*/React.createElement(React.Fragment, null, " (", /*#__PURE__*/React.createElement("span", {
      className: "!text-[#fe561c] !font-bold"
    }, tShort("promo/remaining", {
      ns: "web_promo"
    }), " ", /*#__PURE__*/React.createElement(Countdown, {
      date: promoTag.expires_at,
      renderer: countdownRenderer,
      onComplete: function onComplete() {
        setHasValidTags(false); // Hide tag if expired
      },
      intervalDelay: 1000,
      zeroPadTime: 2
    })), ")"), " - ", formatDiscountAmount(promoTag), " ", /*#__PURE__*/React.createElement("div", {
      className: "w-6 h-1 inline-block"
    }, /*#__PURE__*/React.createElement(SAR, {
      className: "!text-black text-xl px-1 relative block ar:left-1 en:right-1 ar:bottom-3 en:bottom-2 "
    })))));
  })));
};
export default PromoTag;